// React
import React from "react";

// Internal
import { getDataTestId } from "../functions/data-test-ids.jsx";
import { ModalButtonType } from "../modal/modal-constants.jsx";
import { SimpleModal, SimpleModalMessage } from "../simple-modal/simple-modal.jsx";

export function ConfirmationModal(props) {
    const confirm = () => {
        props.OnConfirm(props.Data);
    };

    const getButtons = () => {
        const buttons = [
            {
                Label: props.ConfirmLabel || "Confirm",
                Type: props.ConfirmType || ModalButtonType.Primary,
                OnClick: confirm
            }
        ];

        if (!props.HideCancel) {
            buttons.push({
                Label: props.CancelLabel || "Cancel",
                Type: ModalButtonType.Secondary,
                Visible: true,
                OnClick: props.OnCancel || props.Close
            });
        }
        return buttons;
    };

    return (
        <SimpleModal
            Show={props.Show}
            Title={props.Title || "Confirm"}
            Close={props.Close}
            Buttons={getButtons()}
            DataTestId={props.DataTestId}>
            <SimpleModalMessage
                Message={props.Message}
                DataTestId={getDataTestId(props.DataTestId, "message")} />
        </SimpleModal>
    );
}
